function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { e, b, g, c, f, a, h } from './chunk-I2QGXAA3.js';
import { twMerge, extendTailwindMerge } from 'tailwind-merge';

var ie = {
  twMerge: !0,
  twMergeConfig: {},
  responsiveVariants: !1
},
    x = function x(s) {
  return s || void 0;
},
    N = function N() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }

  return x(e(s).filter(Boolean).join(" "));
},
    R = null,
    v = {},
    q = !1,
    M = function M() {
  for (var _len2 = arguments.length, s = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    s[_key2] = arguments[_key2];
  }

  return function (b$1) {
    return b$1.twMerge ? ((!R || q) && (q = !1, R = b(v) ? twMerge : extendTailwindMerge(_objectSpread(_objectSpread({}, v), {}, {
      extend: _objectSpread({
        theme: v.theme,
        classGroups: v.classGroups,
        conflictingClassGroupModifiers: v.conflictingClassGroupModifiers,
        conflictingClassGroups: v.conflictingClassGroups
      }, v.extend)
    }))), x(R(N(s)))) : N(s);
  };
},
    _ = function _(s, b) {
  for (var _e in b) {
    s.hasOwnProperty(_e) ? s[_e] = N(s[_e], b[_e]) : s[_e] = b[_e];
  }

  return s;
},
    ce = function ce(s, b$1) {
  var _s$extend = s.extend,
      e = _s$extend === void 0 ? null : _s$extend,
      _s$slots = s.slots,
      O = _s$slots === void 0 ? {} : _s$slots,
      _s$variants = s.variants,
      U = _s$variants === void 0 ? {} : _s$variants,
      _s$compoundVariants = s.compoundVariants,
      W = _s$compoundVariants === void 0 ? [] : _s$compoundVariants,
      _s$compoundSlots = s.compoundSlots,
      C = _s$compoundSlots === void 0 ? [] : _s$compoundSlots,
      _s$defaultVariants = s.defaultVariants,
      z = _s$defaultVariants === void 0 ? {} : _s$defaultVariants,
      m = _objectSpread(_objectSpread({}, ie), b$1),
      k = e != null && e.base ? N(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base,
      g$1 = e != null && e.variants && !b(e.variants) ? g(U, e.variants) : U,
      w = e != null && e.defaultVariants && !b(e.defaultVariants) ? _objectSpread(_objectSpread({}, e.defaultVariants), z) : z;

  !b(m.twMergeConfig) && !c(m.twMergeConfig, v) && (q = !0, v = m.twMergeConfig);

  var S = b(e == null ? void 0 : e.slots),
      T = b(O) ? {} : _objectSpread({
    base: N(s == null ? void 0 : s.base, S && (e == null ? void 0 : e.base))
  }, O),
      j = S ? T : _(_objectSpread({}, e == null ? void 0 : e.slots), b(T) ? {
    base: s == null ? void 0 : s.base
  } : T),
      h$1 = b(e == null ? void 0 : e.compoundVariants) ? W : f(e == null ? void 0 : e.compoundVariants, W),
      V = function V(l) {
    if (b(g$1) && b(O) && S) return M(k, l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
    if (h$1 && !Array.isArray(h$1)) throw new TypeError("The \"compoundVariants\" prop must be an array. Received: ".concat(_typeof(h$1)));
    if (C && !Array.isArray(C)) throw new TypeError("The \"compoundSlots\" prop must be an array. Received: ".concat(_typeof(C)));

    var P = function P(a, n) {
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var i = arguments.length > 3 ? arguments[3] : undefined;
      var r = t;
      if (typeof n == "string") r = r.concat(h(n).split(" ").map(function (o) {
        return "".concat(a, ":").concat(o);
      }));else if (Array.isArray(n)) r = r.concat(n.reduce(function (o, c) {
        return o.concat("".concat(a, ":").concat(c));
      }, []));else if (_typeof(n) == "object" && typeof i == "string") {
        for (var o in n) {
          if (n.hasOwnProperty(o) && o === i) {
            var _c = n[o];

            if (_c && typeof _c == "string") {
              var u = h(_c);
              r[i] ? r[i] = r[i].concat(u.split(" ").map(function (f) {
                return "".concat(a, ":").concat(f);
              })) : r[i] = u.split(" ").map(function (f) {
                return "".concat(a, ":").concat(f);
              });
            } else Array.isArray(_c) && _c.length > 0 && (r[i] = _c.reduce(function (u, f) {
              return u.concat("".concat(a, ":").concat(f));
            }, []));
          }
        }
      }
      return r;
    },
        D = function D(a$1) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : g$1;
      var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var L;
      var r = n[a$1];
      if (!r || b(r)) return null;
      var o = (L = i == null ? void 0 : i[a$1]) != null ? L : l == null ? void 0 : l[a$1];
      if (o === null) return null;
      var c = a(o),
          u = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === !0,
          f = w == null ? void 0 : w[a$1],
          d = [];
      if (_typeof(c) == "object" && u) for (var _i = 0, _Object$entries = Object.entries(c); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            E = _Object$entries$_i[0],
            Q = _Object$entries$_i[1];

        var ne = r[Q];

        if (E === "initial") {
          f = Q;
          continue;
        }

        Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(E) || (d = P(E, ne, d, t));
      }
      var $ = c != null && _typeof(c) != "object" ? c : a(f),
          A = r[$ || "false"];
      return _typeof(d) == "object" && typeof t == "string" && d[t] ? _(d, A) : d.length > 0 ? (d.push(A), t === "base" ? d.join(" ") : d) : A;
    },
        p = function p() {
      return g$1 ? Object.keys(g$1).map(function (a) {
        return D(a, g$1);
      }) : null;
    },
        ee = function ee(a, n) {
      if (!g$1 || _typeof(g$1) != "object") return null;
      var t = new Array();

      for (var i in g$1) {
        var r = D(i, g$1, a, n),
            o = a === "base" && typeof r == "string" ? r : r && r[a];
        o && (t[t.length] = o);
      }

      return t;
    },
        H = {};

    for (var _a in l) {
      l[_a] !== void 0 && (H[_a] = l[_a]);
    }

    var I = function I(a, n) {
      var i;
      var t = _typeof(l == null ? void 0 : l[a]) == "object" ? _defineProperty({}, a, (i = l[a]) == null ? void 0 : i.initial) : {};
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, w), H), t), n);
    },
        J = function J() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var n = arguments.length > 1 ? arguments[1] : undefined;
      var t = [];

      var _iterator = _createForOfIteratorHelper(a),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref3 = _step.value;

          var i = _ref3.class,
              r = _ref3.className,
              o = _objectWithoutProperties(_ref3, ["class", "className"]);

          var _c2 = !0;

          for (var _i2 = 0, _Object$entries2 = Object.entries(o); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                u = _Object$entries2$_i[0],
                _f = _Object$entries2$_i[1];

            var d = I(u, n)[u];

            if (Array.isArray(_f)) {
              if (!_f.includes(d)) {
                _c2 = !1;
                break;
              }
            } else {
              var $ = function $(A) {
                return A == null || A === !1;
              };

              if ($(_f) && $(d)) continue;

              if (d !== _f) {
                _c2 = !1;
                break;
              }
            }
          }

          _c2 && (i && t.push(i), r && t.push(r));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return t;
    },
        te = function te(a) {
      var n = J(h$1, a);
      if (!Array.isArray(n)) return n;
      var t = {};

      var _iterator2 = _createForOfIteratorHelper(n),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var i = _step2.value;
          if (typeof i == "string" && (t.base = M(t.base, i)(m)), _typeof(i) == "object") for (var _i3 = 0, _Object$entries3 = Object.entries(i); _i3 < _Object$entries3.length; _i3++) {
            var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
                r = _Object$entries3$_i[0],
                o = _Object$entries3$_i[1];

            t[r] = M(t[r], o)(m);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return t;
    },
        ae = function ae(a) {
      if (C.length < 1) return null;
      var n = {};

      var _iterator3 = _createForOfIteratorHelper(C),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref5 = _step3.value;

          var _ref5$slots = _ref5.slots,
              t = _ref5$slots === void 0 ? [] : _ref5$slots,
              i = _ref5.class,
              r = _ref5.className,
              o = _objectWithoutProperties(_ref5, ["slots", "class", "className"]);

          if (!b(o)) {
            var _c3 = !0;

            for (var _i4 = 0, _Object$keys = Object.keys(o); _i4 < _Object$keys.length; _i4++) {
              var u = _Object$keys[_i4];
              var _f2 = I(u, a)[u];

              if (_f2 === void 0 || (Array.isArray(o[u]) ? !o[u].includes(_f2) : o[u] !== _f2)) {
                _c3 = !1;
                break;
              }
            }

            if (!_c3) continue;
          }

          var _iterator4 = _createForOfIteratorHelper(t),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _c4 = _step4.value;
              n[_c4] = n[_c4] || [], n[_c4].push([i, r]);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return n;
    };

    if (!b(O) || !S) {
      var _a2 = {};

      if (_typeof(j) == "object" && !b(j)) {
        var _loop = function _loop() {
          var n = _Object$keys2[_i5];

          _a2[n] = function (t) {
            var i, r;
            return M(j[n], ee(n, t), ((i = te(t)) != null ? i : [])[n], ((r = ae(t)) != null ? r : [])[n], t == null ? void 0 : t.class, t == null ? void 0 : t.className)(m);
          };
        };

        for (var _i5 = 0, _Object$keys2 = Object.keys(j); _i5 < _Object$keys2.length; _i5++) {
          _loop();
        }
      }

      return _a2;
    }

    return M(k, p(), J(h$1), l == null ? void 0 : l.class, l == null ? void 0 : l.className)(m);
  },
      K = function K() {
    if (!(!g$1 || _typeof(g$1) != "object")) return Object.keys(g$1);
  };

  return V.variantKeys = K(), V.extend = e, V.base = k, V.slots = j, V.variants = g$1, V.defaultVariants = w, V.compoundSlots = C, V.compoundVariants = h$1, V;
},
    fe = function fe(s) {
  return function (b, e) {
    return ce(b, e ? g(s, e) : s);
  };
};

export { M as cn, N as cnBase, fe as createTV, ie as defaultConfig, ce as tv, x as voidEmpty };